import { RemoteConfigSettings } from 'config'
import { useFeatureFlags } from '../../services/featureFlags'

// Loosely based on https://medium.com/javascript-in-plain-english/create-feature-flags-for-your-react-app-with-firebase-remote-config-92d17c5e518d
// If additional logic around versions in the flags is useful, go look up that article again
//
// Currently, this provides access to config settings with a defined type (RemoteConfigSettings),
// ignoring all other settings that may exist on Firebase which are not supported by this app yet
//
// NOTE: This now uses the new useFeatureFlags hook which handles cloud vs on-prem automatically
export const useFlags = (): RemoteConfigSettings => {
  const featureFlags = useFeatureFlags()
  return featureFlags.getFlags()
}

// NOTE: Loading is now handled automatically by the FeatureFlagProvider in ServiceProviders
// This function is kept for backwards compatibility but is now a no-op
export const useLoadFlagsFromRemoteEffect = (): void => {
  // No-op: Feature flag loading is now handled by ServiceProviders
}

export default useFlags
